import type { IntlShape } from "react-intl";

export const useAmazonRegionOptions = (intl: IntlShape) => {
  return {
    regionOptions: [
      {
        text: intl.formatMessage({
          id: "funding-application: amazon seller region - North America",
          defaultMessage: "North America",
        }),
        id: "na",
      },
      {
        text: intl.formatMessage({
          id: "funding-application: amazon seller region - Canada",
          defaultMessage: "Canada",
        }),
        id: "ca",
      },
      {
        text: intl.formatMessage({
          id: "funding-application: amazon seller region - Mexico",
          defaultMessage: "Mexico",
        }),
        id: "mx",
      },
      {
        text: intl.formatMessage({
          id: "funding-application: amazon seller region - Brazil",
          defaultMessage: "Brazil",
        }),
        id: "br",
      },
      {
        text: intl.formatMessage({ id: "funding-application: amazon seller region - Spain", defaultMessage: "Spain" }),
        id: "sp",
      },
      {
        text: intl.formatMessage({ id: "funding-application: amazon seller region - UK", defaultMessage: "UK" }),
        id: "uk",
      },
      {
        text: intl.formatMessage({
          id: "funding-application: amazon seller region - France",
          defaultMessage: "France",
        }),
        id: "fr",
      },
      {
        text: intl.formatMessage({
          id: "funding-application: amazon seller region - Netherlands",
          defaultMessage: "Netherlands",
        }),
        id: "nl",
      },
      {
        text: intl.formatMessage({
          id: "funding-application: amazon seller region - Germany",
          defaultMessage: "Germany",
        }),
        id: "gr",
      },
      {
        text: intl.formatMessage({ id: "funding-application: amazon seller region - Italy", defaultMessage: "Italy" }),
        id: "it",
      },
      {
        text: intl.formatMessage({
          id: "funding-application: amazon seller region - Sweden",
          defaultMessage: "Sweden",
        }),
        id: "se",
      },
      {
        text: intl.formatMessage({
          id: "funding-application: amazon seller region - Poland",
          defaultMessage: "Poland",
        }),
        id: "pl",
      },
      {
        text: intl.formatMessage({
          id: "funding-application: amazon seller region - Turkey",
          defaultMessage: "Turkey",
        }),
        id: "tr",
      },
      {
        text: intl.formatMessage({ id: "funding-application: amazon seller region - India", defaultMessage: "India" }),
        id: "in",
      },
      {
        text: intl.formatMessage({
          id: "funding-application: amazon seller region - Singapore",
          defaultMessage: "Singapore",
        }),
        id: "sg",
      },
      {
        text: intl.formatMessage({
          id: "funding-application: amazon seller region - Australia",
          defaultMessage: "Australia",
        }),
        id: "au",
      },
      {
        text: intl.formatMessage({ id: "funding-application: amazon seller region - Japan", defaultMessage: "Japan" }),
        id: "jp",
      },
      {
        text: intl.formatMessage({ id: "funding-application: amazon seller region - U.A.E", defaultMessage: "U.A.E" }),
        id: "ae",
      },
    ],
    regionCodes: [
      "na",
      "ca",
      "mx",
      "br",
      "sp",
      "uk",
      "fr",
      "nl",
      "gr",
      "it",
      "se",
      "pl",
      "tr",
      "in",
      "sg",
      "au",
      "jp",
      "ae",
    ],
  };
};
